import { CATEGORY_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';

export const getFieldForAnalytics = (fieldType: string, analyticsAlias?: string) => {
	if (analyticsAlias) {
		// keep backwards compatibility
		if (analyticsAlias === CATEGORY_TYPE) {
			return 'category';
		}

		return analyticsAlias;
	}

	return fieldType;
};
